import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
})

queryClient.setQueryDefaults(['users', 'me'], {
  staleTime: 10000
})

queryClient.setQueryDefaults(['roles'], {
  staleTime: Infinity
})

queryClient.setQueryDefaults(['programs'], {
  staleTime: Infinity
})
